<template>
	<apexchart width="100%" type="donut" :options="chartOptions" :series="series"></apexchart>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { mapGetters, mapActions } from 'vuex';

async function created() {
	this.loadStatistics(this.currentSubsidiary);
}

async function loadStatistics(newSubsidiary) {
	if (newSubsidiary.id) {
		try {
			const { data: response } = await this.$http.get(
				`accounting-seats?subsidiaryId=${newSubsidiary.id}`);
			const amountDebit
			= response.map(item => item.totalDebe).reduce((prev, curr) => prev + curr, 0);
			const amountCredit
			= response.map(item => item.totalHaber).reduce((prev, curr) => prev + curr, 0);
			const amountTotal = (amountDebit - amountCredit);
			this.series = [amountDebit, amountCredit, amountTotal];
			this.debit = Number(amountDebit.toFixed(2));
			this.credit = Number(amountCredit.toFixed(2));
			this.amount = Number(amountTotal.toFixed(2));
			this.series = [this.debit, this.credit, this.amount];
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}
}

async function subsidiaryChange(newSubsidiary) {
	this.loadStatistics(newSubsidiary);
}

export default {
	name: 'donut',
	components: { VueApexCharts },
	created,
	methods: {
		...mapActions('subsidiary', {
			$loadSubsidiaries: 'loadSubsidiaries',
			$setCurrentSubsidiary: 'setCurrentSubsidiary',
			$updateSubsidiaries: 'updateSubsidiaries',
		}),
		loadStatistics,
		subsidiaryChange,
	},
	data() {
		return {
			series: [48, 48, 48],
			chartOptions: {
				chart: {
					type: 'donut',
				},
				plotOptions: {
					pie: {
						donut: {
							labels: {
								show: true,
								name: {
									show: true,
									fontSize: '22px',
									fontFamily: 'Helvetica, Arial, sans-serif',
									fontWeight: 600,
									color: undefined,
									offsetY: -10,
									label: 'Total',
								},
							},
							value: {
								show: true,
								fontSize: '16px',
								fontFamily: 'Helvetica, Arial, sans-serif',
								fontWeight: 400,
								color: undefined,
								offsetY: 16,
							},
							total: {
								show: false,
								showAlways: false,
								label: 'Total',
								fontSize: '22px',
								fontFamily: 'Helvetica, Arial, sans-serif',
								fontWeight: 600,
								color: '#373d3f',
							},
						},
					},
				},
				labels: ['Debe', 'Haber', 'Total'],
				responsive: [{
					breakpoint: 480,
					options: {
						chart: {
							width: 100,
						},
						legend: {
							position: 'bottom',
						},
					},
				}],
			},
			debit: 0,
			credit: 0,
			amount: 0,
		};
	},
	computed: {
		...mapGetters('subsidiary', [
			'currentSubsidiary',
		]),
	},
	watch: {
		currentSubsidiary: subsidiaryChange,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/shared/apexCharts/donut.vue